import React from 'react'
import ShippingPageLayout from './ShippingPageLayout'

const ShipmentPage = () => {
  return (
    <ShippingPageLayout>
      <div>ShipmentPage</div>
    </ShippingPageLayout>
  )
}

export default ShipmentPage